import { render, staticRenderFns } from "./OtsTable.vue?vue&type=template&id=5bd5ab42&scoped=true&"
import script from "./OtsTable.vue?vue&type=script&lang=js&"
export * from "./OtsTable.vue?vue&type=script&lang=js&"
import style0 from "./OtsTable.vue?vue&type=style&index=0&id=5bd5ab42&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd5ab42",
  null
  
)

export default component.exports